import { render, staticRenderFns } from "./DepotManage.vue?vue&type=template&id=24ac799a&scoped=true"
import script from "./DepotManage.vue?vue&type=script&lang=js"
export * from "./DepotManage.vue?vue&type=script&lang=js"
import style0 from "./DepotManage.vue?vue&type=style&index=0&id=24ac799a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac799a",
  null
  
)

export default component.exports